<rotec-modal-v2 [width]="width" [height]="height" [darkMode]="true">
  @if (title) {
    <ng-container ngProjectAs="modal-main">
      <div class="duplicate-rotor-type__title" translate>Duplicating {{ title }}</div>
      <div class="duplicate-rotor-type__content" translate>
        <div class="main-info">
          <rotec-text-input-v2
            [darkMode]="true"
            [hasError]="uniqueNameError"
            [placeholder]="getDuplicatedTitle(title)"
            [value]="getDuplicatedTitle(title)"
            (valueChange)="setDuplicatedValue($event)"
          ></rotec-text-input-v2>
          @if (uniqueNameError) {
            <div class="error-message" translate>
              Rotor type name already exists. Please choose another name.
            </div>
          }
        </div>
      </div>
    </ng-container>
  }

  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark (click)="close()">
      {{ 'Cancel' | translate }}
    </button>
    <button rotec-button-active dark (click)="apply()" [disabled]="uniqueNameError">
      {{ 'Save' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
